'use client';

import { LoginWhite } from '@/app/components/icons/LoginWhite';
import type { ClosingCTASectionData } from '../../types';
import { PortableTextContent } from '../PortableTextContent';
import { SectionShell } from '../section-shared';

export function ClosingCTASection({ section }: { section: ClosingCTASectionData }) {
  const backgroundImageUrl = 'https://image01.cf.vidu.studio/vidu/media-asset/tools_cta_bg-671f90df.webp';

  return (
    <SectionShell className="overflow-hidden pb-24 sm:pb-16">
      <div
        className="-translate-x-1/2 pointer-events-none absolute top-0 left-1/2 h-full w-screen bg-center bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${backgroundImageUrl})` }}
      />
      <div className="relative flex flex-col items-center text-center">
        <LoginWhite className="text-[43px] text-white sm:text-[32px]" />
        <h2 className="mx-auto mt-10 w-full font-semibold text-[48px] text-white leading-[1.2] sm:mt-8 sm:text-[30px]">
          {section.title}
        </h2>
        <PortableTextContent className="mx-auto mt-4 w-full" value={section.description} />
        {section.button?.href && section.button?.label && (
          <a
            className="mt-14 inline-flex h-16 items-center justify-center rounded-2xl bg-[#0086FF] px-8 font-semibold text-[22px] text-white transition-colors hover:bg-[#0f91ff] sm:mt-8 sm:h-14 sm:text-lg"
            href={section.button.href}
            rel={/^https?:\/\//.test(section.button.href) ? 'noreferrer' : undefined}
            target={/^https?:\/\//.test(section.button.href) ? '_blank' : undefined}
          >
            {section.button.label}
          </a>
        )}
      </div>
    </SectionShell>
  );
}
